class detailSelect {
  constructor(container) {
    this.container = container;
    this.options = container.querySelectorAll('.we-select > .we-select__item');
    const checkedInput = container.querySelector('input:checked');
    this.value = checkedInput ? checkedInput.value : (this.options[0]?.querySelector('input')?.value ?? '');
    this.mouseDown = false;
    this._addEventListeners();
    this._setAria();
    this._setInitialActive();
    this.updateValue();
  }

  _addEventListeners() {
    this.container.addEventListener('toggle', () => {
      if (this.container.open) return;
      this.updateValue();
    });

    this.container.addEventListener('focusout', (e) => {
      if (this.mouseDown) return;
      this.container.removeAttribute('open');
    });

    this.options.forEach((opt) => {
      const input = opt.querySelector('input');
      if (input) {
        input.addEventListener('change', () => {
          this.setChecked(input);
        });
      }
      opt.addEventListener('mousedown', () => {
        this.mouseDown = true;
      });
      opt.addEventListener('mouseup', () => {
        this.mouseDown = false;
        this.container.removeAttribute('open');
      });
    });

    this.container.addEventListener('keyup', (e) => {
      const keycode = e.which;
      const current = [...this.options].indexOf(this.container.querySelector('.active'));
      const currentIdx = current >= 0 ? current : 0;
      switch (keycode) {
        case 27: // ESC
          this.container.removeAttribute('open');
          break;
        case 35: // END
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[this._getNextSelectableIndex(this.options.length, 'prev')]?.querySelector('input'));
          break;
        case 36: // HOME
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[this._getNextSelectableIndex(-1, 'next')]?.querySelector('input'));
          break;
        case 38: // UP
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[this._getNextSelectableIndex(currentIdx, 'prev')]?.querySelector('input'));
          break;
        case 40: // DOWN
          e.preventDefault();
          if (!this.container.open) this.container.setAttribute('open', '');
          this.setChecked(this.options[this._getNextSelectableIndex(currentIdx, 'next')]?.querySelector('input'));
          break;
      }
    });
  }

  _setAria() {
    this.container.setAttribute('aria-haspopup', 'listbox');
    const weSelect = this.container.querySelector('.we-select');
    if (weSelect) weSelect.setAttribute('role', 'listbox');
    const summary = this.container.querySelector('.we-select-container__summary');
    if (summary) {
      summary.setAttribute('aria-label', summary.getAttribute('aria-label') || 'Select option');
      summary.setAttribute('aria-live', 'polite');
    }
    this.options.forEach((opt) => {
      opt.setAttribute('role', 'option');
    });
  }

  _setInitialActive() {
    const checked = this.container.querySelector('input:checked');
    if (checked) {
      this.options.forEach((opt) => {
        opt.classList.remove('active');
        opt.setAttribute('aria-selected', 'false');
      });
      checked.closest('.we-select__item')?.classList.add('active');
      checked.closest('.we-select__item')?.setAttribute('aria-selected', 'true');
    }
  }

  updateValue() {
    const that = this.container.querySelector('input:checked');
    if (!that) return;
    this.setValue(that);
  }

  setChecked(that) {
    if (!that || that.disabled) return;
    that.checked = true;
    this.setValue(that);
  }

  _getNextSelectableIndex(currentIdx, direction) {
    const step = direction === 'prev' ? -1 : 1;
    for (let i = currentIdx + step; i >= 0 && i < this.options.length; i += step) {
      const input = this.options[i]?.querySelector('input');
      if (input && !input.disabled) return i;
    }
    return currentIdx;
  }

  setValue(that) {
    if (!that || this.value === that.value) return;

    const summary = this.container.querySelector('.we-select-container__summary');
    const label = that.closest('.we-select__item')?.querySelector('label');
    const pos = [...this.options].indexOf(that.closest('.we-select__item')) + 1;

    if (summary && label) {
      const summaryValueSpan = summary.querySelector('.we-select-container__summary-value');
      if (summaryValueSpan) {
        summaryValueSpan.innerHTML = label.innerHTML;
      } else {
        summary.innerHTML = label.innerHTML;
      }
      summary.setAttribute('aria-label', `${that.value}, listbox ${pos} of ${this.options.length}`);
    }

    const labelId = this.container.getAttribute('data-label-id');
    if (labelId) {
      const labelEl = document.getElementById(labelId);
      if (labelEl) {
        labelEl.textContent = label ? label.textContent.trim() : that.value;
      }
    }

    this.value = that.value;

    this.options.forEach((opt) => {
      opt.classList.remove('active');
      opt.setAttribute('aria-selected', 'false');
    });
    that.closest('.we-select__item')?.classList.add('active');
    that.closest('.we-select__item')?.setAttribute('aria-selected', 'true');

    that.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (typeof window !== 'undefined') {
  window.detailSelect = detailSelect;
}
